import React, { useEffect, useState } from "react";
import { Link, useNavigate, useLocation, useParams } from "react-router-dom";
import { GoArrowLeft } from "react-icons/go";
import { LuCalendarClock, LuPencil } from "react-icons/lu";
import { LuMoveRight } from "react-icons/lu";
import { HiOutlineSave } from "react-icons/hi";
import {
  Listbox,
  ListboxButton,
  ListboxOption,
  ListboxOptions,
} from "@headlessui/react";
import { FaCheck } from "react-icons/fa";
import { MdKeyboardArrowDown } from "react-icons/md";
import clsx from "clsx";
import {
  LuCircleAlert,
  LuCalendar,
  LuClock,
  LuBuilding,
  LuMapPin,
  LuFileText,
  LuUser,
} from "react-icons/lu";
import { FaUserDoctor } from "react-icons/fa6";
import { MdPhone, MdOutlineMailOutline } from "react-icons/md";
import { FiPhone } from "react-icons/fi";
import { useLazyGetAppointmentDetailsByIdQuery } from "../../../State/Api/AdddocApiSlice";

function ClinicsideAppointmentDetails() {
  const navigate = useNavigate();
const { appointmentId, userClinicId } = useParams();
  const location = useLocation();
   const preloadedDetails = location.state?.details;
  const [details, setDetails] = useState(preloadedDetails || null);

  const [getDetails, { isLoading }] = useLazyGetAppointmentDetailsByIdQuery();

  useEffect(() => {
    if (!preloadedDetails && appointmentId && userClinicId) {
      (async () => {
        try {
          const result = await getDetails({ appointmentId, userClinicId });
          setDetails(result.data);
        } catch (err) {
          console.error("Error fetching details:", err);
        }
      })();
    }
  }, [appointmentId, userClinicId, preloadedDetails]);



  const handleReschedule = async () => {
  
      const patientName=details?.patientFullName;
      const doctorName=details?.doctorFullName;
      const doctorSpecialization=details?.department;
      const appointmentID=details?.appointmentID;
      const doctorID = details?.doctorID;
      const patientUserUniqueID = details?.userUniqueID;

       navigate("/AddAppointment", {
  state: {
    showModal: true,
    fromRescheduleView: {
      patientName,
      doctorSpecialization,
      doctorName,
      appointmentID,
      doctorID,
      patientUserUniqueID
    },
  },
});
   
};

  const appointmentStyles = `
  .bg-greenlayer {
    background-color:  #42ff99b0;/
}

.gradient-avatar {
  height: 48px;
  width: 48px;
  border-radius: 9999px;
//   background: linear-gradient(to bottom right, #F6743E, #D42525);
background: linear-gradient(to bottom right, #213343, #25d45b);
  color: white;
  font-weight: 600;
  font-size: 1.3rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

  `;

  const patient = {
    name: details?.patientFullName || "N/A",
    dob: details?.dateofBirth
      ? new Date(details.dateofBirth).toLocaleDateString()
      : "N/A",
    address: details?.address || "N/A",
    phone: details?.patientContact || "N/A",
    email: details?.emailAddress || "N/A",
  };

  const doctor = {
    name: details?.doctorFullName || "N/A",
    dob: details?.department || "N/A",
    phone: details?.doctorContact || "N/A",
    email: details?.doctorEmail || "N/A",
  };

  const getInitials = (name) => {
    return name
      .split(" ")
      .map((n) => n[0])
      .join("")
      .toUpperCase();
  };

  const options = [
    { id: 1, name: "Approved", route: "" },
    { id: 2, name: "Move Prescription", route: "" },
  ];

  const [selected, setSelected] = useState(null); // null for placeholder

  const handleChange = (option) => {
    setSelected(option);
    navigate(option.route);
  };

  return (
    <>
      <style>{appointmentStyles}</style>
      <div className="flex flex-col gap-3">
        <div className="flex items-center justify-between gap-4 flex-wrap">
          <div className="flex items-center gap-4 flex-wrap">
            <Link to="/clinic/appointments">
              <button className="bg-[#fff] inline-flex items-center justify-center shrink-0 gap-2 whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 border border-input bg-background hover:bg-accent hover:text-accent-foreground size-10">
                <GoArrowLeft />
                <span className="sr-only">Back</span>
              </button>
            </Link>
            <div>
              <h1 className="text-2xl lg:text-3xl font-bold tracking-tight mb-2">
                Appointment Details
              </h1>
              {/* <p className="text-muted-foreground">
                View and manage Appointment details for your patients.
              </p> */}
            </div>
          </div>

          <div className="flex gap-2 flex-wrap">
            {/* <button
              type="button"
              onClick={() =>
                navigate("/prescriptionform", {
                  state: {
                    PatientuserUniqueID: details?.userUniqueID,
                    appointmentDate: (details?.appointmentDate).toString().split("T")[0],
                      
                  },
                })
              }
              className="gradient-button inline-flex items-center justify-center shrink-0 gap-2 whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 border border-input bg-background hover:bg-accent hover:text-accent-foreground h-10 px-4 py-2"
            >
              <LuMoveRight className="mr-2 h-4 w-4" />
              Move Prescription
            </button> */}

            
              <button onClick={handleReschedule}  className="gradient-button  inline-flex items-center justify-center shrink-0 gap-2 whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 border border-input bg-background hover:bg-accent hover:text-accent-foreground h-10 px-4 py-2">
                <LuCalendarClock className="mr-2 h-4 w-4" />
                Reschedule
              </button>
            
            {/* <button
              href="/appointments/1/edit"
              className="gradient-button inline-flex items-center justify-center shrink-0 gap-2 whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors  h-10 px-4 py-2"
            >
              <HiOutlineSave className="mr-2 h-4 w-4" />
              Submit
            </button> */}
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div className="rounded-lg border bg-card text-card-foreground shadow-sm md:col-span-2">
            <div className="p-3 md:p-4 xxl:p-6 flex flex-row items-start justify-between space-y-0">
              <div>
                <h2 className="xl:text-2xl text-2xl font-semibold mb-2 tracking-tight flex items-center gap-2">
                  <LuCircleAlert className="shrink-0 h-5 w-5 text-blue-500" />
                  {details?.appointmentType || "N/A"}
                </h2>
                <div className="text-sm text-muted-foreground">
                  Appointment #{details?.appointmentID} • Created on{" "}
                  {details?.appointmentCreatedDate
  ? new Date(details.appointmentCreatedDate).toLocaleDateString('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
    }).replace(/ /g, '-')
  : 'N/A'}
                </div>
              </div>

              <div className="inline-flex items-center rounded-full border px-1.5 md:px-2.5 py-0.5 whitespace-nowrap text-xs font-semibold border-blue-500 text-blue-500">
                {details?.status || "Scheduled"}
              </div>
            </div>
            <div className="p-3 md:p-4 xxl:p-6 space-y-6">
              {/* Section: Date, Time, Department, Location, Reason, Notes */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="space-y-4">
                  <div className="flex items-start gap-3">
                    <LuCalendar className="shrink-0 h-5 w-5 text-muted-foreground mt-0.5" />
                    <div>
                      <h3 className="font-semibold">Date</h3>
                      <p>{details?.appointmentDate
  ? new Date(details.appointmentDate).toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    }).replace(/ /g, "-")
  : "N/A"}
</p>
                    </div>
                  </div>

                  <div className="flex items-start gap-3">
                    <LuClock className="shrink-0 h-5 w-5 text-muted-foreground mt-0.5" />
                    <div>
                      <h3 className="font-semibold">Time</h3>
                      <p>{details?.timeSlot || "N/A"}</p>
                    </div>
                  </div>

                  <div className="flex items-start gap-3">
                    <LuBuilding className="shrink-0 h-5 w-5 text-muted-foreground mt-0.5" />
                    <div>
                      <h3 className="font-semibold">Department</h3>
                      <p>{details?.department || "N/A"}</p>
                    </div>
                  </div>
                </div>

                <div className="space-y-4">
                  <div className="flex items-start gap-3">
                    <LuFileText className="shrink-0 h-5 w-5 text-muted-foreground mt-0.5" />
                    <div>
                      <h3 className="font-semibold">Appointment Type</h3>
                      <p>{details?.appointmentType || "N/A"}</p>
                    </div>
                  </div>

                  <div className="flex items-start gap-3">
                    <LuFileText className="shrink-0 h-5 w-5 text-muted-foreground mt-0.5" />
                    <div>
                      <h3 className="font-semibold">Notes</h3>
                      <p className="text-sm">
                        {details?.existingMedicalConditions ||
                          "No additional notes"}
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Divider */}
              <div role="none" className="shrink-0 bg-border h-[1px] w-full" />

              {/* Section: Vital Signs */}
              <div>
                <h3 className="font-semibold mb-3">Vital Signs</h3>
                <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                  <div className="bg-greenlayer  rounded-lg p-3">
                    <p className="text-sm text-muted-foreground">
                      Blood Pressure
                    </p>
                    <p className="font-medium">
                      {details?.bloodPressure || "N/A"}
                    </p>
                  </div>
                  <div className="bg-greenlayer  rounded-lg p-3">
                    <p className="text-sm text-muted-foreground">Pulse Rate</p>
                    <p className="font-medium">{details?.pulse || "N/A"}</p>
                  </div>
                  <div className="bg-greenlayer  rounded-lg p-3">
                    <p className="text-sm text-muted-foreground">Temperature</p>
                    <p className="font-medium">
                      {details?.temperature || "N/A"} C</p>
                  </div>

                  <div className="bg-greenlayer  rounded-lg p-3">
                    <p className="text-sm text-muted-foreground">Height</p>
                    <p className="font-medium">{details?.height || "N/A"} cm</p>
                  </div>
                  <div className="bg-greenlayer  rounded-lg p-3">
                    <p className="text-sm text-muted-foreground">Weight</p>
                    <p className="font-medium">{details?.weight || "N/A"} kg</p>
                  </div>
                </div>
              </div>

              {/* Divider */}
              <div role="none" className="shrink-0 bg-border h-[1px] w-full" />
            </div>
          </div>

          <div className="space-y-6">
            <div className="rounded-lg border bg-card text-card-foreground shadow-sm">
              {/* Header */}
              <div className="flex flex-col space-y-1.5 p-3 md:p-4 xxl:p-6">
                <h2 className="xl:text-2xl text-xl font-semibold mb-2 tracking-tight flex items-center gap-2">
                  <LuUser className="h-5 w-5" />
                  Patient Information
                </h2>
              </div>

              {/* Body */}
              <div className="p-3 md:p-4 xxl:p-6 space-y-4">
                {/* Avatar + Name */}
                <div className="flex items-center gap-3">
                  <div className="h-12 w-12 rounded-full flex items-center justify-center text-white font-semibold text-sm gradient-avatar">
                    {getInitials(patient.name)}
                  </div>
                  <div>
                    <h3 className="font-semibold">{patient.name}</h3>
                    <p className="text-sm text-muted-foreground">
                      DOB: {patient?.dob
  ? new Date(patient.dob).toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    }).replace(/ /g, "-")
  : "N/A"}

                    </p>
                  </div>
                </div>

                {/* Divider */}
                <div
                  role="none"
                  className="shrink-0 bg-border h-[1px] w-full"
                />

                {/* Contact Info */}
                <div className="space-y-2">
                  <div className="grid grid-cols-[20px_1fr] gap-2 items-start">
                    <LuMapPin className="h-4 w-4 text-muted-foreground mt-1" />
                    <p className="text-sm">{patient.address}</p>
                  </div>

                  <div className="grid grid-cols-[20px_1fr] gap-2 items-center">
                    <FiPhone className="h-4 w-4 text-muted-foreground" />
                    <p className="text-sm">{patient.phone}</p>
                  </div>

                  <div className="grid grid-cols-[20px_1fr] gap-2 items-center">
                    <MdOutlineMailOutline className="h-4 w-4 text-muted-foreground" />
                    <p className="text-sm">{patient.email}</p>
                  </div>
                </div>

                {/* View Button */}
                {/* <div className="pt-2">
                  <a
                    href="/patients/p1"
                    className="inline-flex items-center justify-center shrink-0 gap-2 whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 border border-input bg-background hover:bg-accent hover:text-accent-foreground h-10 px-4 py-2 w-full"
                  >
                    View Patient Record
                  </a>
                </div> */}
              </div>
            </div>

            <div className="space-y-6">
            <div className="rounded-lg border bg-card text-card-foreground shadow-sm">
              {/* Header */}
              <div className="flex flex-col space-y-1.5 p-3 md:p-4 xxl:p-6">
                <h2 className="xl:text-2xl text-xl font-semibold mb-2 tracking-tight flex items-center gap-2">
                  <FaUserDoctor className="h-5 w-5" />
                  Doctor Information
                </h2>
              </div>

              {/* Body */}
              <div className="p-3 md:p-4 xxl:p-6 space-y-4">
                {/* Avatar + Name */}
                <div className="flex items-center gap-3">
                  <div className="h-12 w-12 rounded-full flex items-center justify-center text-white font-semibold text-sm gradient-avatar">
                    {getInitials(doctor.name)}
                  </div>
                  <div>
                    <h3 className="font-semibold">{doctor.name}</h3>
                    <p className="text-sm text-muted-foreground">
                      {doctor.dob}
                    </p>
                  </div>
                </div>

                {/* Divider */}
                <div
                  role="none"
                  className="shrink-0 bg-border h-[1px] w-full"
                />

                {/* Contact Info */}
                <div className="space-y-2">
                  <div className="grid grid-cols-[20px_1fr] gap-2 items-center">
                    <FiPhone className="h-4 w-4 text-muted-foreground" />
                    <p className="text-sm">{doctor.phone}</p>
                  </div>

                  <div className="grid grid-cols-[20px_1fr] gap-2 items-center">
                    <MdOutlineMailOutline className="h-4 w-4 text-muted-foreground" />
                    <p className="text-sm">{doctor.email}</p>
                  </div>
                </div>

                {/* View Button */}
                {/* <div className="pt-2">
                  <a
                    href="/patients/p1"
                    className="inline-flex items-center justify-center shrink-0 gap-2 whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 border border-input bg-background hover:bg-accent hover:text-accent-foreground h-10 px-4 py-2 w-full"
                  >
                    View Patient Record
                  </a>
                </div> */}
              </div>
            </div>
          </div>
          </div>
          
        </div>
      </div>
    </>
  );
}

export default ClinicsideAppointmentDetails;
